"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderTileGroup = exports.TileGroup = exports.tileGroupQuantityInPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const TileGroupComponent_1 = require("./TileGroupComponent");
const TileGroupControl_1 = require("./TileGroupControl");
const TilesGroupService_1 = require("../../TilesGroupService");
const app_1 = require("app");
exports.tileGroupQuantityInPage = 0;
const TileGroup = ({ apiUrl, redirectUrl, totalCount, pageSize, dictionary, loadMoreBtnLabel, loadLessBtnLabel, defaultImageType, isDescriptionExpandable, tileType, tileShape, groupType, checkAllBtnLabel, culture, currentPageId, tags, types, offset, items, }) => {
    const wrapperRef = React.useRef(null);
    const MAXIMUM_COUNT_OF_TILES_TO_SHOW_PAGINATION = 9;
    const [TILE_GROUP_ID] = React.useState(`tileGroup_${exports.tileGroupQuantityInPage + 1}`);
    const TileGroupUrlState = app_1.UrlService.GetQueryObjectValueFromUrl(TILE_GROUP_ID);
    const isPaginated = React.useMemo(() => totalCount > MAXIMUM_COUNT_OF_TILES_TO_SHOW_PAGINATION && !redirectUrl, [redirectUrl, totalCount]);
    const [state, setState] = React.useState({
        service: new TilesGroupService_1.default(apiUrl, isPaginated),
        tiles: items,
        additionalTiles: [],
        tilesToShow: [],
        statusInfo: null,
        isExpanded: false,
        paginationInfo: {
            currentPageIndex: +(TileGroupUrlState === null || TileGroupUrlState === void 0 ? void 0 : TileGroupUrlState.page) - 1 || 0,
            tilesPerPage: +(TileGroupUrlState === null || TileGroupUrlState === void 0 ? void 0 : TileGroupUrlState.pageSize) || pageSize,
        },
    });
    React.useEffect(() => {
        ++exports.tileGroupQuantityInPage;
    }, []);
    const { service, tiles, additionalTiles, tilesToShow, statusInfo, isExpanded, paginationInfo } = state;
    React.useEffect(() => {
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { tilesToShow: [...tiles, ...additionalTiles] });
        });
    }, [additionalTiles, tiles]);
    const initialQueryParams = React.useMemo(() => {
        return { tags, types, culture, offset, pageSize, currentPageId };
    }, [culture, currentPageId, offset, pageSize, tags, types]);
    const controlLabels = React.useMemo(() => ({
        loadMoreBtnLabel,
        loadLessBtnLabel,
        checkAllBtnLabel,
    }), [checkAllBtnLabel, loadLessBtnLabel, loadMoreBtnLabel]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "react-tile-group__wrapper expand-wrapper", ref: wrapperRef, children: [(0, jsx_runtime_1.jsx)(TileGroupComponent_1.default, { items: tilesToShow, statusInfo: statusInfo, tileType: tileType, tileShape: tileShape, totalCount: totalCount, groupType: groupType, dictionary: dictionary, defaultImageType: defaultImageType, isDescriptionExpandable: isDescriptionExpandable }), (0, jsx_runtime_1.jsx)(TileGroupControl_1.default, { setWrapperState: setState, tileGroupId: TILE_GROUP_ID, labels: controlLabels, initialPageSize: pageSize, totalCount: totalCount, isExpanded: isExpanded, redirectUrl: redirectUrl, initialQueryParams: initialQueryParams, wrapperRef: wrapperRef, paginationInfo: paginationInfo, service: service })] }));
};
exports.TileGroup = TileGroup;
const RenderTileGroup = (data, el) => {
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(exports.TileGroup, Object.assign({}, data)), el);
};
exports.RenderTileGroup = RenderTileGroup;
